import { ICreateControlePatrimonioUseCase } from "../../../presentation/useCases/create/create_controle_patrimonio_use_case";
import { IControlePatrimonioRepository } from "../../repositories/ControledePatrimonio";

import dayjs from "dayjs";

/**
 * CreateControlePatrimonioUseCase
 */

export class CreateControlePatrimonioUseCase implements ICreateControlePatrimonioUseCase {
  constructor(private readonly repository: IControlePatrimonioRepository) { }

  async createControlePatrimonio(
    ativo: number | null,
    dataCadastro: Date | null,
    codigo: string | null,
    idCentroCusto: number | null,
    descricao: string | null,
    criterioAceitacao: string | null,
    referenciaAceitacao: string | null,
    quantidade: number | null,
    dataAquisicao: Date | null,
    dataGarantia: Date | null,
    descResponsavelMonit: string | null,
    idFuncionarioMonit: number | null,
    idFornecedorMonit: number | null,
    descResponsavelResp: string | null,
    idFuncionarioResp: number | null,
    tipoMonitoramento: number | null,
    frequenciaVerificacao: number | null,
    dataProxVerificacao: Date | null,
    dataVerificacao: Date | null,
    marca: string | null,
    modelo: string | null,
    valor: number | null,
    tipo: string | null,
    idFornecedor: number | null,
    status: number | null,
    fatorGerador: number | null,
    faixaDeUso: string | null,
    localizacao: string | null,
    observacao: string | null,
    tipoCalibradoMonit: number | null
  ): Promise<number> {
    return await this.repository.createControlePatrimonio(
      ativo === 1,
      dataCadastro ?? dayjs(new Date()).local().utc().toDate(),
      codigo,
      idCentroCusto,
      descricao,
      criterioAceitacao,
      referenciaAceitacao,
      quantidade !== null ? quantidade : 1,
      dataAquisicao,
      dataGarantia,
      descResponsavelMonit,
      idFuncionarioMonit,
      idFornecedorMonit,
      descResponsavelResp,
      idFuncionarioResp,
      tipoMonitoramento === 1 ? 'C' : tipoMonitoramento === 0 ? 'V' : 'N',
      frequenciaVerificacao,
      dataProxVerificacao,
      dataVerificacao,
      marca,
      modelo,
      valor,
      tipo,
      idFornecedor,
      status,
      fatorGerador,
      faixaDeUso,
      localizacao,
      observacao,
      tipoCalibradoMonit
    );
  }
}
